@if (terminal$ | async; as terminal) {
  @if (terminal.shorePower) {
  <ng-container>
    @if (terminal.boxSupplier === itransactBoxSupplier) {
      <!-- ITransact section (unchanged) -->
      <app-form-group>
        <app-info class="formGroupLabel">
          <label>Request shore power ?</label>
          <div class="tooltipContent">The vessel’s email address will be used to send the access code. This enables the crew to unlock the shore‑power facility.</div>
        </app-info>
        <app-yes-no [(ngModel)]="shorePower.shorePowerEnabled" (ngModelChange)="resetShorePowerDetails($event)" id="shorePowerEnabled" required [disabled]=pinCodeReceived>
        </app-yes-no>
      </app-form-group>

      @if (shorePower?.shorePowerEnabled) {
        <app-shore-power-details [shorePower]="shorePower"></app-shore-power-details>
        <app-form-group>
          <app-info class="formGroupLabel">
            <label>PIN</label>
            <div class="tooltipContent">Pin code received from the shore-power provider</div>
          </app-info>

          <app-form-group>
            @if (showPinCode) {
              <label id="pinCode" class="label-pinCode" (dblclick)="selectPinCode($event)">{{ shorePower.pinCode }}</label>
            } @else {
              <label for="pinCode" class="label-placeholder">{{ pinCodePlaceholder }}</label>
            }
          </app-form-group>
        </app-form-group>
      }
    }

    @if (terminal.boxSupplier === hollandAmerikaKadeBoxSupplier) {
      <!-- Holland Amerikakade section (provider-less: Yes/No + exemption only) -->
      <app-form-group>
        <app-info class="formGroupLabel">
          <label>Request shore power ?</label>
          <div class="tooltipContent">
            <div>Voltage: 6,6 / 11 kV</div>
            <div>Frequency: 50 / 60 Hz</div>
          </div>
        </app-info>
        <app-yes-no [(ngModel)]="shorePower.shorePowerEnabled" (ngModelChange)="onHollandAmerikaKadeShorePowerEnabledChange($event)" id="shorePowerEnabled" required>
        </app-yes-no>
      </app-form-group>

      @if (shorePower?.shorePowerEnabled === false) {
        <app-form-group>
          <app-info class="formGroupLabel">
            <label>Exemption</label>
            <div class="tooltipContent">{{ exemptionInfoText(shorePower.exemption) }}</div>
          </app-info>
          <app-select [(ngModel)]="shorePower.exemption" id="shorePowerExemption" required
                      [options]="shorePowerExemptions" [formatter]="exemptionFormatter">
          </app-select>
        </app-form-group>

        @if (showForm29Banner) {
          <div class="alert alert-warning fade show mb-0" role="alert" id="shorePowerForm29Banner">
            <span>You must submit a General Exemption Form (Form 29)</span>
          </div>
        }
      }
    }

  </ng-container>
  }
}
